import type { FaireProductEntity } from "../../entity_types/product";

export const p_kumzeswk5m: FaireProductEntity = {
  token: "p_kumzeswk5m",
  type: "product",
  name: "Mommy and Me Matching Beanies [BABY]",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/d2259701b234b66c7cf6d519d72ef2b0c10ba7866becda0505f189c3592ceae1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d32c2c06101872d8caced461c799e1ea360ea98cda6d80e7508803521fa23653.jpeg",
    "https://cdn.faire.com/fastly/ee39c3797f884561759f7682c965bc2ac5ccc575b6db39e7935b35a018aae035.jpeg",
    "https://cdn.faire.com/fastly/5c3df86397608fb9b57d39fe2618315791ccee5dc435152126944e1b68bc5312.jpeg",
    "https://cdn.faire.com/fastly/b05a30d9a24e0f76044612a175bb5fea56fc2f253a152a299441d7dd668da5eb.jpeg",
    "https://cdn.faire.com/fastly/7c7ff125cc9b068939057b394a1371f9f553495c4a42ea66ac8d3885d79147ee.jpeg",
    "https://cdn.faire.com/fastly/41f749d321c9d9e1af8100b7ccee7af9aad91aee12f619115365e75f374b2a8b.jpeg",
    "https://cdn.faire.com/fastly/a3b340b5822588ec8d0fb33f6a60f704023444a95464d1ed4f4ab92cb09e7db1.jpeg",
    "https://cdn.faire.com/fastly/75d2f57b1b3bee29dfee4494e594452ac6d9d367713e5e90b70e6d48f3f46801.jpeg",
    "https://cdn.faire.com/fastly/899003f72ee3cec6f296e658da1ef42f7c1d72b65166b254db3fb0ddc8831cdf.jpeg",
    "https://cdn.faire.com/fastly/ea5501e1259a32711e9f71c00c514efb8a16034701ab1db0470f21bd52055bd6.jpeg",
    "https://cdn.faire.com/fastly/9ec6fa2d96e80270c2f14ff25f0fb9307be750b23a89371bc923a5592aadc449.jpeg",
    "https://cdn.faire.com/fastly/762c505a2fbb7e0cd567aaef80f1577bb52fdbf52d128111a3490f89fa154189.jpeg",
    "https://cdn.faire.com/fastly/e8e7e051f3a21ee3ac8de74164d894d11bfafd2645fe949c329df37c9274b602.jpeg",
  ],
  priceDollars: 34.57,
  description:
    " Mommy and Me Matching Beanies [Baby] \n\n***Comes with 1 Adult Beanie+1 Baby Beanie***\n- Criss Cross Knitted Design\n- Faux Fur Pom-Pom Attached\n- 47% Rayon, 31% PBT, 22% Nylon\n- Baby Hat ( For 0 to 9 months )\n\n**Some Colors may not be the exact match**\n",
  tags: [],
  msrpDollars: 103.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:56.856Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
